/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FavoriteCategories } from '../models/FavoriteCategories';
import type { FavoriteCategory } from '../models/FavoriteCategory';
import type { FavoriteItems } from '../models/FavoriteItems';
import { request as __request } from '../core/request';

export class FavoriteCategoryService {

    /**
     * get favorite categories
     * @returns FavoriteCategories get list of company favorite category
     * @throws ApiError
     */
    public static async getFavoriteCategory({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<FavoriteCategories> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/favorite/category`,
        });
        return result.body;
    }

    /**
     * add favorite category
     * @returns FavoriteCategory favorite category added
     * @throws ApiError
     */
    public static async addFavoriteCategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: FavoriteCategory,
}): Promise<FavoriteCategory> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/favorite/category`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update favorite category
     * @returns FavoriteCategory Favorite Category updated
     * @throws ApiError
     */
    public static async updateFavoriteCategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: FavoriteCategory,
}): Promise<FavoriteCategory> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/favorite/category`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * delete Favorite Category
     * @returns FavoriteCategory Favorite category deleted
     * @throws ApiError
     */
    public static async deleteFavoriteCategory({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: FavoriteCategory,
}): Promise<FavoriteCategory> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/favorite/category`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * get user favorite items
     * @returns FavoriteItems get list of company favorite category
     * @throws ApiError
     */
    public static async getUserFavoriteItem({
companyId,
employeeId,
}: {
/** The companyId **/
companyId: number,
/** The employeeId **/
employeeId: number,
}): Promise<FavoriteItems> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/favorite/${employeeId}/thing`,
        });
        return result.body;
    }

    /**
     * add favorite category
     * @returns FavoriteItems favorite items added
     * @throws ApiError
     */
    public static async addUserFavoriteItems({
companyId,
employeeId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The employeeId **/
employeeId: number,
requestBody: FavoriteItems,
}): Promise<FavoriteItems> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/favorite/${employeeId}/thing`,
            body: requestBody,
        });
        return result.body;
    }

}